<template>
  <div
    class="modal"
    tabindex="-1"
    :id="id"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-ice">
        <div class="modal-header bg-cosmos p-3">
          <span>{{ headerText }}</span>
          <modal-close-button @confirmed="closeModal()" />
        </div>
        <div class="modal-body fs-14">
          <!-- SPRACHE -->
          <div
            class="row mb-3"
            v-if="languages.length > 1 && !resendConfirmationMailResponse"
          >
            <div class="col-12 mb-2">
              <span class="text-bold">
                {{
                  $t(
                    'global.pleaseselectlanguageincaseofnocorrespondencelanguage'
                  )
                }}
              </span>
            </div>
            <div class="col-12 d-flex flex-wrap justify-content-between">
              <div
                class="mr-3"
                v-if="languages.includes('DE')"
              >
                <input
                  id="DE"
                  v-model="language"
                  type="radio"
                  value="1751CDBCE1E"
                />
                <label
                  class="ml-2"
                  for="DE"
                >
                  {{ $t('global.german') }}
                </label>
              </div>

              <div
                class="mr-3"
                v-if="languages.includes('EN')"
              >
                <input
                  id="EN"
                  v-model="language"
                  type="radio"
                  value="180BC941F1F"
                />
                <label
                  class="ml-2 mr-3"
                  for="EN"
                >
                  {{ $t('global.english') }}
                </label>
              </div>

              <div
                class="mr-3"
                v-if="languages.includes('FR')"
              >
                <input
                  id="FR"
                  v-model="language"
                  type="radio"
                  value="186559F7DBF"
                />
                <label
                  class="ml-2 mr-3"
                  for="FR"
                >
                  {{ $t('global.french') }}
                </label>
              </div>

              <div
                class="mr-3"
                v-if="languages.includes('IT')"
              >
                <input
                  id="IT"
                  v-model="language"
                  type="radio"
                  value="187B79C94AC"
                />
                <label
                  class="ml-2 mr-3"
                  for="IT"
                >
                  {{ $t('global.italian') }}
                </label>
              </div>
            </div>
          </div>
          <div
            class="row mb-3"
            v-if="languages.length == 1 && !resendConfirmationMailResponse"
          >
            <div class="col-12 mb-2 d-flex">
              <span class="mr-2 text-bold">
                {{ $t('global.availablelanguage') }}:
              </span>
              <div v-if="languages.includes('DE')">
                {{ $t('global.german') }}
              </div>
              <div v-if="languages.includes('EN')">
                {{ $t('global.english') }}
              </div>
              <div v-if="languages.includes('FR')">
                {{ $t('global.french') }}
              </div>
              <div v-if="languages.includes('IT')">
                {{ $t('global.italian') }}
              </div>
            </div>
          </div>
          <div v-if="resendConfirmationMailResponse">
            <div v-if="resendConfirmationMailResponse.successes?.length > 0">
              {{ $t('global.actionsuccessful') }}:
            </div>
            <div
              v-for="(
                message, index
              ) in resendConfirmationMailResponse.successes || []"
              :key="index"
              class="mb-2"
            >
              <p>- {{ message }}</p>
            </div>
            <div v-if="resendConfirmationMailResponse.errors?.length > 0">
              {{ $t('global.error') }}:
            </div>
            <div
              v-for="(
                message, index
              ) in resendConfirmationMailResponse.errors || []"
              :key="index"
              class="mb-2"
            >
              <p>- {{ message }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row w-100">
            <div class="col-12 p-0 d-flex justify-content-between text-center">
              <button
                type="button"
                class="btn btn-danger mr-3"
                data-dismiss="modal"
                @click="onCancel"
              >
                <span class="font-khand font-weight-bold">
                  {{ $t('global.cancel') }}
                </span>
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="onOk"
                :disabled="!formIsValid"
              >
                <span class="font-khand font-weight-bold">{{ okText }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
  import AppApi from '@/api/AppApi'
  import page from '@/mixins/Page'

  import ModalCloseButton from '@/components/global/ModalCloseButton'

  export default {
    name: 'RegistrationConfirmationResendModal',
    components: {
      ModalCloseButton,
    },
    mixins: [page],
    props: {
      id: {
        type: String,
        default: 'registration-confirmation-resend-modal',
      },
      headerText: {
        type: String,
        default: 'Bestätigungsmail versenden',
      },
      okText: {
        type: String,
        default: 'OK',
      },
      languages: {
        type: Array,
        default: () => [],
      },
      isShortEvent: {
        type: Boolean,
        default: false,
      },
      courseId: {
        type: String,
        default: null,
      },
      selectedIds: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        headerTitel: null,
        language: null,
        resendConfirmationMailResponse: null,
        loading: false,
      }
    },
    computed: {
      formIsValid() {
        if (this.languages.length > 0 && !this.language) return false

        return true
      },
    },
    mounted() {
      if (this.languages.length == 1) this.language = this.languages[0]

      this.$bus.$on('openResendRegistrationConfirmationModal', () => {
        if (!this.shown) this.openModal()
      })
    },
    methods: {
      openModal() {
        $('#' + this.id).modal({
          backdrop: 'static',
          keyboard: false,
        })
      },

      closeModal() {
        this.shown = false
        $('#' + this.id).modal('hide')
      },
      onCancel() {
        this.resendConfirmationMailResponse = null
        this.closeModal()
      },
      onOk() {
        if (this.resendConfirmationMailResponse) {
          this.closeModal()
          this.resendConfirmationMailResponse = null
        } else {
          this.resendRegistrationConfirmationMail(this.language)
        }
      },
      resendRegistrationConfirmationMail(langId) {
        this.loading = true
        const params = {
          lang: langId,
          isShortEvent: this.isShortEvent,
          course: this.courseId,
        }

        AppApi.post('registration-confirmation-resend/', this.selectedIds, {
          params: params,
        })
          .then((response) => {
            this.resendConfirmationMailResponse = response.data
            if (response.data.errors.length > 0) {
              this.$notify({
                type: 'warn',
                title: this.$t('global.actionfailed'),
                text: this.$t('global.registrationconfirmationresendfailed'),
              })
              // display errors in Modal
              console.log(response.data.errors)
            } else {
              console.log('no errors')
              this.$notify({
                type: 'success',
                title: this.$t('global.actionsuccessful'),
                text: this.$t(
                  'global.registrationconfirmationresendedsuccessfully'
                ),
              })

              // display success message in modal
            }
          })
          .catch((error) => {
            console.error(error)
            this.$notify({
              type: 'warn',
              title: this.$t('global.actionfailed'),
              text: this.$t('global.registrationconfirmationresendfailed'),
            })
          })
          .finally(() => {
            /*           this.$bus.$emit(
            "openMessageBoxEnhanced",
            "resendConfirmationMail-alert-msgbox"
          ); */
            this.loading = false
          })
      },
    },
  }
</script>
